import React from 'react'
import Layout from '../../component/Layout';
import FeatureDetail from '../../component/FeatureDetail';
import { useParams } from 'react-router-dom';
import { t } from 'i18next';

const FEATURE_TITLE_KEYS = {
	recording: 'recording_options',
	lockdown: 'lockdown_options',
	verification: 'verification_options',
	system: 'system_options',
	ai: 'ai_features',
	'quiz-tools': 'quiz_tools',
};

const FeaturesDetailContainer = () => {
	const { id } = useParams();
	const titleKey = FEATURE_TITLE_KEYS[id] || id;
	return (
		<Layout title={t(titleKey)} description={t("features_desc")}>
			<FeatureDetail key={id} />
		</Layout>
	)
}

export default FeaturesDetailContainer
